import React, { useEffect, useState } from 'react'

import flyer from "../../images/Eventflyer-Bild_196x270.jpg";
import banner from "../../images/banner.jpg";
import bannerDesktop from "../../images/banner_desktop.jpg";
import bannerMobile from "../../images/banner_mobile.jpg";
import masterclassheader from "../../images/masterclass-header.png";
import { useNavigate, useParams } from 'react-router-dom';

const Header = (props) => {

    let navigate = useNavigate();

    const { language } = useParams();

    const { masterclass, homeDescriptionHeader, recommendedEventsHeader, voucherEventHeader } = props;

    const currentPathname = window.location.pathname;

    const [isMobile, setIsMobile] = useState(window.innerWidth < 885);

    document.documentElement.lang = language;

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 885);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const handleChangeLanguage = (e) => {
        const newLanguage = e.target.value;
        const newPathname = currentPathname.replace(`/${language}/`, `/${newLanguage}/`);
        navigate(newPathname);
    }

    // Select the appropriate banner image based on screen size
    const bannerImage = masterclass ? masterclassheader : (isMobile ? bannerMobile : bannerDesktop);

    return (
        <div>
            <div className='text-end pt-3' style={{ justifyContent: "right", display: "flex" }}>
                <div style={{ minWidth: "70px" }}>
                    <select
                        className='language-select form-select fw-semibold'
                        onChange={(e) => handleChangeLanguage(e)}
                    >
                        <option value="de" selected={language == "de"}>de</option>
                        <option value="fr" selected={language == "fr"}>fr</option>
                        <option value="it" selected={language == "it"}>it</option>
                        <option value="en" selected={language == "en"}>en</option>
                    </select>
                </div>
            </div>
            {/*<div>*/}
                {/*<img className='text-center flyer' src={flyer} alt="expovina flyer"></img>*/}
            {/*</div>*/}
            <div className='row mt-4'>
                <div className='col-12 fill'>
                    <img className='img-fluid' src={bannerImage} alt="expovina banner"></img>
                </div>
            </div>
            {(masterclass == true) ? <></> : <div className="mb-4 mt-4">
                {homeDescriptionHeader && <p className="fs-4 fw-bold">{props.resources?.Title}</p>}
                {voucherEventHeader && <p className="fs-4 fw-bold">{props.resources?.Title}</p>}
                {homeDescriptionHeader && !recommendedEventsHeader && !voucherEventHeader && <p className="fs-5 fw-semibold" dangerouslySetInnerHTML={{ __html: props.resources?.SubTitle }} ></p>}
                {voucherEventHeader && <p className="fs-5 fw-semibold" dangerouslySetInnerHTML={{ __html: props.resources?.SubTitleVoucher }} ></p>}
            </div>}
            {recommendedEventsHeader &&
                <div className="mb-4 mt-4">
                    <p className="fs-4 fw-bold recommended-events-header">{props.resources?.RecommendedEventsHeader}</p>
                </div>}
        </div>
    )
}

export default Header